import React from 'react';
import { FileText } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
import { Button } from '../ui/Button';
export function Hero() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <section className="bg-background px-5 py-10 md:px-6 md:py-14" data-id="element-272" data-mp="jnx89q9kq5jb">
      <div className="mx-auto max-w-5xl text-center" data-id="element-273" data-mp="eqoo5k4v7rff">
        <p className="eyebrow inline-flex items-center justify-center gap-2 text-ink/75" data-id="element-274" data-mp="epvgmgy30xw8">
          <span className="h-2 w-2 rounded-full bg-peach" data-id="element-275" data-mp="apv10sz8ygnl" />
          Property Law &amp; Conveyancing · Australia-wide
        </p>

        <h1 className="mx-auto mt-5 max-w-4xl font-serif text-[2.65rem] leading-[1.04] tracking-tight text-ink sm:text-[3.35rem] lg:text-[4.25rem] lg:leading-[1.02]" data-id="element-276" data-mp="qdwwfzn8atq">
          Clear legal advice before you{' '}
          <span className="text-brand-blue" data-id="element-277" data-mp="1v45293axw8jd">buy, sell or sign</span>.
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-muted-ink md:text-xl" data-id="element-278" data-mp="1q5am694cwy2y">
          Lawyer-led conveyancing for property matters across Australia, from
          contract review and disclosure advice through to a settlement that
          actually lands on time.
        </p>

        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-279" data-mp="1cy6alvz8ogwg">
          <Button onClick={openUpload} variant="accent" size="lg" className="w-full sm:w-auto" data-id="element-280" data-mp="1d09ar8u3vqew">
            <FileText className="h-5 w-5" data-id="element-281" data-mp="25mka6g5z7la4" />
            Upload a contract
          </Button>
          <Button onClick={openQuote} variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-282" data-mp="2am6n0ohw6zie">
            Get a free quote
          </Button>
        </div>
      </div>
    </section>;
}